import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideNgxMask } from 'ngx-mask';

import { PublicFooterComponent } from '@sondermind/features/app-footer';
import { ConfigurationModule } from '@sondermind/configuration';
import { DatadogLoggingModule } from '@sondermind/datadog-logging';
import { PublicHeaderModule } from '@sondermind/features/app-header';
import { BrowseTherapistsCard } from '@sondermind/features/browse-therapists-card';
import { PageNotFoundComponent } from '@sondermind/features/page-not-found';
import { ProviderCalendarComponent } from '@sondermind/features/public-facing/provider-calendar';
import { QuickCheckoutComponent } from '@sondermind/features/public-facing/session-request';
import { SupportPhoneNumberCardComponent } from '@sondermind/features/support-phone-number-card';
import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisIconComponent } from '@sondermind/iris/icon';
import { IrisIconButtonModule } from '@sondermind/iris/icon-button';
import { IrisProgressBarModule } from '@sondermind/iris/progress-bar';
import { IrisRadioGroupModule } from '@sondermind/iris/radio-group';
import { LoggingInitModule } from '@sondermind/logging-init';
import { NativeAppInterfaceModule } from '@sondermind/native-app-interface';
import { AUTH_SERVICE } from '@sondermind/utilities/models-auth';
import { ENVIRONMENT } from '@sondermind/utilities/models-environment';
import { WINDOW } from '@sondermind/utilities/tools';
import { FEATURE_FLAG_SERVICE, FeatureFlagCiService } from '@sondermind/data-access/feature-flags';
import { AppService } from '@sondermind/data-access/app-service';
import { AmplitudeFeatureFlagService } from '@sondermind/amplitude';
import { ProviderProfilePageModule } from '@sondermind/features/provider-profile-page';
import { DirectBookingComponentService } from '@sondermind/features/direct-booking';

import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    PageNotFoundComponent,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    ProviderProfilePageModule,
    DatadogLoggingModule.forRoot(environment),
    IrisButtonModule,
    IrisCardModule,
    IrisIconButtonModule,
    IrisIconComponent,
    IrisRadioGroupModule,
    IrisProgressBarModule,
    ProviderCalendarComponent,
    PublicFooterComponent,
    PublicHeaderModule,
    SupportPhoneNumberCardComponent,
    QuickCheckoutComponent,
    AppRoutingModule,
    ConfigurationModule,
    LoggingInitModule,
    ProviderCalendarComponent,
    NativeAppInterfaceModule,
    BrowseTherapistsCard
  ],
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: WINDOW, useValue: window },
    { provide: AUTH_SERVICE, useValue: { getAuthToken: () => '' } },
    {
      provide: AppService,
      useValue: {
        ready: () => {}
      }
    },
    provideNgxMask(),
    {
      provide: FEATURE_FLAG_SERVICE,
      useFactory: (
        amplitudeFeatureFlagService: AmplitudeFeatureFlagService,
        featureFlagCiService: FeatureFlagCiService
      ) => (environment.ci ? featureFlagCiService : amplitudeFeatureFlagService),
      deps: [AmplitudeFeatureFlagService, FeatureFlagCiService]
    },
    DirectBookingComponentService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
